module.exports = __webpack_public_path__ + "static/img/X8智驾域控制器SDC200.b821f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/自动驾驶作业系统SAD200/X8智驾域控制器SDC200.png
// module id = IM5g
// module chunks = 0